/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionChecked2: {
  name: 'temp-selection-checked-2';
  data: string;
} = {
  name: 'temp-selection-checked-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v14H5V5Zm11.768 4.64a1 1 0 1 0-1.536-1.28l-4.3 5.159-2.225-2.226a1 1 0 0 0-1.414 1.414l2.226 2.226a2 2 0 0 0 2.95-.134l4.3-5.159Z" fill="currentColor"/></svg>`,
};
